import { EnvConfig } from '../config';

export const config: EnvConfig = {
  gtmId: 'GTM-N53DH7Z',
  gtmAuth: 'jmruCX9Wf-UE51Ceaa19nw',
  gtmPreview: 'env-7',
  splitIoAuthKey: 'djvj9shq0j30h1d6puedd61k41jlfsh9nevq',
};
